export default "__VITE_ASSET__ZB1zGZbI__"